import { styled, forBrands, Theme, CSSObject } from '@core-ui/react-stitch';

const defaultStyles = (): CSSObject => ({
  fontSize: '14px',
  lineHeight: '18px',
  fontWeight:700,
  fontFamily:'Source Sans Pro',
  fontStyle:'normal'
});

const brandStyles = (
  theme: Theme
) =>
  forBrands(theme, {
    default: defaultStyles
  }) as CSSObject;

const Container = styled.div(
  ({ theme }) => ({
    color: '#333333',
    textTransform: 'none',
    ...brandStyles(theme)
  })
);

export default Container;
